export function getUtcDayName(date) {
    const dayTable = {
        1: 'Pondělí',
        2: 'Úterý',
        3: 'Středa',
        4: 'Čtvrtek',
        5: 'Pátek',
        6: 'Sobota',
        0: 'Neděle',
    };
    if (date instanceof Date) {
        const day = date.getUTCDay();
        return dayTable[day];
    }
    return null;
}
export function formatDate(value, displayDayName = false) {
    if (typeof value !== 'string')
        return null;
    const date = new Date(value);
    let month = String(date.getUTCMonth() + 1);
    let day = String(date.getUTCDate());
    const year = String(date.getUTCFullYear());
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    if (displayDayName) {
        const dayName = getUtcDayName(date);
        if (dayName) {
            return [day, month, year].join('.') + ', ' + dayName;
        }
    }
    return [day, month, year].join('.');
}
export function ymdToDmy(value) {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!value.match(regEx))
        return null;
    const [year, month, day] = value.split('-');
    return `${day}.${month}.${year}`;
}
export function dateRange(from, to) {
    if (!from && !to)
        return '';
    if (from && !to)
        return `od ${ymdToDmy(from)}`;
    if (!from && to)
        return `do ${ymdToDmy(to)}`;
    if (from && to)
        return `${ymdToDmy(from)}-${ymdToDmy(to)}`;
}
